import ViewBase from "./view_base";
import ModelBase from "./model_base";
import GameUtil from "../../../utility/game_util";
import ModuleManager from "../module_manager";
import AppData from '../../../pacakge/public/const/app_data';
import MVVMBase from './mvvm_base';
import Utility from "../../../utility/utility";
import ModelData, { IUserData } from "../../../pacakge/public/model_data";
import UserDataManager, { IUserCurrencyData } from "../../../manager/user_manager";
import LogManager from "../../../manager/log_manager";
import { ModuleHideRelease } from '../../../config/module_config';


const { ccclass, property } = cc._decorator;


export enum ViewLayer {
    Low,
    Mid,
    High,
    Highest,
}

declare interface IWaitDealData {
    key?: string;
    data: any;
    handle?: Function;
    target?: any;
}

export let moduleTypeNames = {};

//预加载的资源
export let preloadResUrls = [];

//nodeName支持"|"分隔符，可以聚焦一起处理Button的事件
export function bindButtonClickEvent(nodeName : string,closeSound ?: boolean) {
    return function bind(target: any, propertyName: string, descriptor: PropertyDescriptor) {
        target.onButtonClickEventFunctions = target.onButtonClickEventFunctions ? target.onButtonClickEventFunctions : {}
        target.onButtonClickEventFunctions[nodeName] = {}
        target.onButtonClickEventFunctions[nodeName].func = propertyName 
        target.onButtonClickEventFunctions[nodeName].closeSound = closeSound
    }
}

//nodeName支持"|"分隔符，可以聚焦一起处理Toggle的事件
export function bindToggleClickEvent(nodeName : string,closeSound ?: boolean) {
    return function bind(target: any, propertyName: string, descriptor: PropertyDescriptor) {
        target.onToggleClickEventFunctions = target.onToggleClickEventFunctions ? target.onToggleClickEventFunctions : {}
        if (nodeName.includes("|")) {
            nodeName.split("|").forEach((value) => {
                target.onToggleClickEventFunctions[value] = {}
                target.onToggleClickEventFunctions[value].func = propertyName
            })
        } else {
            target.onToggleClickEventFunctions[nodeName] = {}
            target.onToggleClickEventFunctions[nodeName].func = propertyName 
        }
    }
}

export function moduleInit(moduleClassName : string, quietLoad ?: boolean,  packageName ?: string, preloadResUrls ?: string[]) {
    return function bind(target: any) {
        target.moduleClassName = moduleClassName
        target.packageName = packageName
        target.quietLoad = quietLoad
        moduleTypeNames[moduleClassName] = target
        // ModuleManager.instance.registModule(moduleClassName, target)
    }
}


declare interface ISubscribeData{

    propertyName? : string;
    mapData? : any[];
    ignoreModuleActive?: boolean;

}

export function subscribeMsg(msgData : any[], ignoreModuleActive : boolean = false){
    return function (target, propertyKey: string, descriptor: PropertyDescriptor){  

        let data : ISubscribeData = {};
        data.ignoreModuleActive = ignoreModuleActive;
        data.mapData = msgData;
        data.propertyName = propertyKey;
        
        if (!target.subscribeMsgList) {
            target.subscribeMsgList = []
        }
        target.subscribeMsgList.push(data);    

    }
}

function propertyEvent(eventName : string) {
    return function (target: any, propertyName: string) {
        target.string = eventName
    }
}

export function implementFunction(funName: string){
    return function(target: any, propertyName: string){
        target[funName] = target[propertyName]
    }
}




@ccclass
export default class Module<V extends ViewBase, M extends ModelBase> extends MVVMBase {
    public package: string
    public moduleName: string

    //显示ID，会依次累加
    private static _showId = 0

    public windowPrefabResPath: string;
    protected viewType;
    protected modelType;
    public moduleType

    //静默加载
    public quietLoad
    
    
    private _inLoading : boolean;
    public get inLoading() : boolean {
        return this._inLoading;
    }
    public set inLoading(v : boolean) {
        this._inLoading = v;
    }
    

    //是否延迟显示
    protected needDeferShow = false  

    protected clickAnywhereClose = true//是否点击任何地方关闭
    protected needAnim: boolean = false//是否需要打开关闭动画
    protected needViewMask: boolean = false


    protected needViewBaseBg: boolean = false
    protected needViewBaseBgMid: boolean = false
    protected needViewBaseBgMini:boolean = false
    protected needViewBaseTitleBg: boolean = false
    protected needViewBaseCloseBtn: boolean = false


    private _viewBaseBg: cc.Node = null
    private _viewBaseCloseBtn: cc.Node = null
    private _viewBaseTitleBg: cc.Node = null
    protected _viewMask: cc.Node = null//view 界面遮罩

    public layer: ViewLayer = ViewLayer.Low;
    protected view: V;
    protected model: M;
    protected intentData: any
    protected waitDealQueue: IWaitDealData[] = []
    private isShowState: boolean
    protected completeCallback: (module : Module<V, M>, state : boolean) => void
    //自定义
    protected customCompleteCallback: (module : Module<V, M>, state : boolean) => void
    protected mPrefab: cc.Prefab = null
    protected autoShowAnim: boolean = true

    public onButtonClickEventFunctions
    public onToggleClickEventFunctions

    public subscribeMsgList : ISubscribeData[] ;

    public hideTriggerDestroy : boolean

    get showId(): number {
        return this.moduleType._showId
    }

    public registerMsg(){
        let self = this;
        if (this.subscribeMsgList) {
            this.subscribeMsgList.forEach(element => {       
                this.model.subscibeMsgEvent(element.mapData,function (propertyName,protoData){   
                    self[propertyName](protoData);
                }.bind(this,element.propertyName),element.ignoreModuleActive);
            });
        }
    }



    onShow(intentData: any) {
        this.DealAllWaitDealQueue();             
    }

    protected onHide() {

    }

    //重置module 所有事件注销
    resetModule() { }

    onInit(intentData: any) { }

    //模块初始化完成，但是View还没初始化完成
    onModuleInit(intentData: any) { }

    on_destroy(): any { }

    init(intentData?: any, completeCallback?: (module, state: boolean) => void) {
        let self = this;
        this.setShowState(true)
        this.intentData = intentData;
        //TODO: 怎么才能获取V的类型呢

        if (this.modelType != null) {
            this.model = new this.modelType();
            this.model.module = this;
        }

        this.onModuleInit(intentData)

        this.loadViewMask()        
        // if (AppData.language != "cn") {
        //     let newResPath = this.windowPrefabResPath + "_" + AppData.language
        //     //@ts-ignore
        //     if (cc.loader._getResUuid(newResPath)) {
        //         this.windowPrefabResPath = newResPath
        //     }
        // }
        let loadTimestamp = new Date().getTime();
        cc.log("请求加载模块prefab:", this.windowPrefabResPath)
        let netPromptsShow = false
        if (!this.quietLoad && !ModuleManager.instance.moduleHasActive("NetPrompt") && this.moduleName != "NetPrompt") {
            netPromptsShow = true
            ModuleManager.instance.showModuleName("NetPrompt", true ? null : { "showImmediately": true})
        }
        this.loadRes(this.windowPrefabResPath, function (err, prefab: cc.Prefab) {
            cc.log("加载模块prefab返回：", self.windowPrefabResPath, (new Date().getTime() - loadTimestamp) / 1000 + "S")
            if (netPromptsShow && self.moduleName != "NetPrompt") {
                ModuleManager.instance.hideModule("NetPrompt")
            }
            if (err) {
                cc.warn("load module prefab error:", self.windowPrefabResPath)
                //TODO:加载失败怎么办
                // if (completeCallback) {
                //     completeCallback(false)
                // }
                return
            }

            //TODO:防止在网络很差的情况下，过了很久才回包，打乱当前的模块打开逻辑
            if (new Date().getTime() - loadTimestamp > 12000) {
                cc.log("加载模块prefab超时：", self.windowPrefabResPath)
                return
            }

            if (self.isDestroyed || !self.node) {
                cc.log(self.moduleName, " 模块已经被销毁")
                return
            }

            if (self.view && self.view.node) {
                cc.log(self.moduleName, " 模块已经加载过了")
                if (!self.isShowState && self.isHide) {
                    self.node.active = false
                    cc.warn(self.moduleName, "最后的状态是隐藏！！！！")
                    return
                } else {
                    self.moduleBaseShow(self.intentData, completeCallback)
                }
                return
            }

            let newNode = cc.instantiate(prefab)
            self.mPrefab = prefab
            self.node.addChild(newNode);
            let viewBase = newNode.getComponent<V>(self.viewType);
            self.view = viewBase    
            self.loadBaseBg()        
            viewBase._moduleBase = self
            let widget = newNode.addComponent(cc.Widget)
            widget.isAlignTop = true;
            widget.isAlignBottom = true;
            widget.isAlignLeft = true;
            widget.isAlignRight = true;
            widget.target = self.node.parent;
            widget.alignMode = cc.Widget.AlignMode.ON_WINDOW_RESIZE;            
            if (!self.isInited) {
                self.onInit(self.intentData);
            }
            self.isInited = true;
            self.registUserDataEvent()
            if (!self.isShowState && self.isHide) {
                self.node.active = false
                cc.error(self.moduleName, "最后的状态是隐藏！！！！")
                return
            } else {
                self.moduleBaseShow(self.intentData, completeCallback)
            }
        })
    }

    private loadViewMask() {
        if (this.needViewMask && this._viewMask == null) {
            let mask = new cc.Node()
            mask.name = "mask"
            mask.parent = this.node
            mask.scale = 1
            let sprite = mask.addComponent(cc.Sprite)
            let button = mask.addComponent(cc.Button)
            button.node.on('click', () => {
                if(this.clickAnywhereClose) this.hide()
            }, this)
            sprite.type = cc.Sprite.Type.SLICED
            sprite.sizeMode = cc.Sprite.SizeMode.CUSTOM
            mask.opacity = 204
            this._viewMask = mask
            mask.active = false
            GameUtil.loadRes("image/mask", function (err, spriteFrame: cc.SpriteFrame) {
                if (err) {
                    cc.warn("load mask error:", err)
                    return
                }
                if (sprite && sprite.isValid) {
                    sprite.spriteFrame = spriteFrame
                }
                if (mask && mask.isValid) {
                    // mask.setContentSize(4000, 2500)
                    let widget = mask.addComponent(cc.Widget)
                    widget.isAlignTop = true;
                    widget.isAlignBottom = true;
                    widget.isAlignLeft = true;
                    widget.isAlignRight = true;
                    widget.target = mask.parent.parent;
                    widget.alignMode = cc.Widget.AlignMode.ON_WINDOW_RESIZE;
                }
            }, cc.SpriteFrame)
        }
    }

    private loadBaseBg(onFinish?: Function){
        let self = this
        let checkCloseBtn = function(nodeCloseBtn, show){
            if(show){
                nodeCloseBtn.active = true
                nodeCloseBtn.on('click', self.on_click_base_close_btn, self)
            }else{
                nodeCloseBtn.active = false
                nodeCloseBtn.off('click', self.on_click_base_close_btn, self)
            }
        }        
        if (self.needViewBaseBg ||self.needViewBaseBgMid || self.needViewBaseBgMini) 
        {
            if(!self._viewBaseBg)
            {
                let path:string=""
                if(self.needViewBaseBg)
                {
                    path="package/hall/module/base_bg/base_bg"
                }
                else if(self.needViewBaseBgMid)
                {
                    path="package/hall/module/base_bg/base_bg_mid"
                }
                else{
                    path="package/hall/module/base_bg/base_bg_mini"
                }
                GameUtil.loadRes(path, function (err, prefab: cc.Prefab) 
                {
                    if (err) 
                    {
                        cc.warn("load mask error:", err)
                        return
                    }
                    if (prefab && prefab.isValid) {
                        let node = cc.instantiate(prefab)
                        self._viewBaseBg = node
                        node.parent = self.view.node
                        node.zIndex = -1
                        node.position = cc.Vec3.ZERO
                        node.active = true
                        let nodeCloseBtn = cc.find('_baseCloseBtn', node)
                        let nodeTitleBg = cc.find('title_bg', node)
                        self._viewBaseCloseBtn = nodeCloseBtn
                        self._viewBaseTitleBg = nodeTitleBg
                        self._viewBaseTitleBg.active = !!self.needViewBaseTitleBg
                        checkCloseBtn(nodeCloseBtn, self.needViewBaseCloseBtn)
                        onFinish && onFinish()
                    }                
                }, cc.Prefab)
            }else{
                self._viewBaseBg.active = true
                self._viewBaseTitleBg.active = !!self.needViewBaseTitleBg
                checkCloseBtn(self._viewBaseCloseBtn, self.needViewBaseCloseBtn)
                onFinish && onFinish()
            }            
        }else{
            if(self._viewBaseBg){
                self._viewBaseBg.active = false
                self._viewBaseTitleBg.active = !!self.needViewBaseTitleBg
                checkCloseBtn(self._viewBaseCloseBtn, false)
            }
            onFinish && onFinish()
        }
    }

    protected on_click_base_close_btn(node: cc.Node){
        Utility.playButtonSound();
        this.hide()
    }

    private _moduleBaseShow(intentData?: any, completeCallback?: (module, state: boolean) => void) {
        ++(this.moduleType._showId)
        this._moduleShowId = this.moduleType._showId
        cc.warn("Module ShowId：", this.moduleName, this._moduleShowId)
        if (!this.isInited) {
            this.init(intentData, completeCallback)
            cc.error("打开模块(上次打开资源未加载成功)：", this.moduleName, this.windowPrefabResPath)
            return
        }
        this.setShowState(true)
        if (this.isDestroyed) {//destroy在这一帧结束调用！
            cc.error("打开模块(view已经销毁)：", this.moduleName, this.windowPrefabResPath)
            return
        }
        if (!this.node.active) {
            this.node.active = true;
        }
        this.isHide = false
        this.view._moduleShowId = this._moduleShowId
        this.onShow(intentData)
        this.view.onShow(intentData);        
        this.onSelfCurrencyDataUpdate && this.onSelfCurrencyDataUpdate(UserDataManager._selfCurrencyData)
        if(ModelData.instance.roleData && ModelData.instance.roleData.id){
            let userData = UserDataManager._userDatas[ModelData.instance.roleData.id.toString()]
            userData && this.onUserDataUpdate && this.onUserDataUpdate(userData)
        }   
        if (intentData && typeof (intentData) == "string" && intentData == "tips") {
            this.view.node.active = false
            if (this._viewMask) {
                this._viewMask.active = false
            }
        } else {
            if (this.autoShowAnim) {//自动播放动画，否则等待module完成请求后自己调用动画方法
                this.showAnim(true)
            }
        }
        if (this.completeCallback) {
            this.completeCallback(this, true)
        }

        this.inLoading = false;
        
        LogManager.instance.log(`ShowModule：${this.moduleName}`)
    }

    moduleBaseShow(intentData?: any, completeCallback?: (module, state: boolean) => void) {
        this.intentData = intentData;
        this.completeCallback = completeCallback;
        if (!this.needDeferShow) {
            this._moduleBaseShow(intentData, completeCallback)
        } else { //需要延迟显示
            this.node.active = false
            this.isHide = false
            this.onDeferShow(this.intentData)
        }
    }

    //延迟显示
    protected onDeferShow(intentData: any) {

    }

    //手动显示，一般是与延迟显示一起使用
    protected show() {
        if (this.needDeferShow) {
            this.node.active = true
            this._moduleBaseShow(this.intentData, this.completeCallback)
        }
    }
    
    

    showLayerTop() {
        this.node.setSiblingIndex(this.node.parent.childrenCount - 1)
    }

    showAnim(open = true) {
        if (!this.view) {
            return
        }
        if (this._viewMask && this._viewMask.active == false) {
            this._viewMask.active = true
        }
        if (this.needAnim) {
            if (open) {
                ModuleManager.instance.playAnim(true, this.view.node, this._viewMask, this.scheduleShow.bind(this))
            } else {
                ModuleManager.instance.playAnim(false, this.view.node, this._viewMask, this.scheduleHide.bind(this))
            }
        } else {
            if (open) {
                this.scheduleShow()
            } else {
                this.scheduleHide()
            }
        }
    }

    showNetPrompt(show: boolean) {
        if (show) {
            ModuleManager.instance.showModuleName("NetPrompt")
        } else {
            ModuleManager.instance.hideModule("NetPrompt")
        }
    }

    private scheduleShow() {
        if (this.view) {
            this.view.node.scale = 1
            //this.view.node.active = true
        }
    }

    private scheduleHide() {
        if (!this.node) {
            return
        }
        if (this.node.active) {
            this.node.active = false;
        }
        this.onHide()
    }

    hide() {
        cc.warn("hideModule：", this.moduleName)
        if (AppData.memoryRecyclingLevel == 2 && ModuleHideRelease.includes(this.moduleName)) {
            ModuleManager.instance.destroyModule(this.moduleName, AppData.memoryRecyclingLevel > 0)
            return
        }
        this.isHide = true
        this.setShowState(false)
        this.CleanWaitDealQueue();
        if (this.node && this.node.active) {
            this.node.active = false;
        }
        // this.showAnim(false)
        this.onHide()
    }

    setShowState(isShow: boolean){
        this.isShowState = isShow
    }

    destroyModule(release?: boolean) {   
        if (this.isDestroyed) {
            return
        }

        this.isDestroyed = true
        this.node.destroy();            
        this.node.active = false

        this.isHide = true
        //TODO:直接Destroy是否会暂停所有事件
        // this.node.stopAllActions()

        this.on_destroy()
        this._baseDestroy(release)
        if (this.view) {
            cc.warn("destroyView", this.view.node.name)
            this.view.destroyView(release);
            this.view = null;
        }
        if (this.model) {
            this.model.destroyModel()
        }
        this.unscheduleAllCallbacks()
        this.setShowState(false)
    }

    AddToWaitDealQueue(data: IWaitDealData) {
        this.waitDealQueue.push(data)
    }

    AddHandleToWaitDealQueue(handle: Function, data: any, target?: any) {
        let waitDealData = {
            handle: handle,
            target: target,
            data: data,
        }
        this.AddToWaitDealQueue(waitDealData);
    }

    GetWaitDealQueueHead(): IWaitDealData {
        if (this.waitDealQueue.length > 0) {
            return this.waitDealQueue.shift();
        }
        return null;
    }

    DealAllWaitDealQueue() {
        for (const key in this.waitDealQueue) {
            if (this.waitDealQueue.hasOwnProperty(key)) {
                const element = this.waitDealQueue[key];
                if (element.handle) {
                    let handle = element.handle
                    if (element.target) {
                        handle = handle.bind(element.target);
                    }
                    handle(element.data);
                }
            }
        }
        this.CleanWaitDealQueue();
    }

    CleanWaitDealQueue() {
        this.waitDealQueue = [];
    }

    _ButtonClick(node: cc.Node, customEventData) {
        let nodeName = node.name
        let funcName = this.onButtonClickEventFunctions ? this.onButtonClickEventFunctions[nodeName] : null
        
        if(!(funcName && funcName.closeSound)){
            Utility.playButtonSound();//在这里统一播声音吧
        }
        
        if (funcName) {
            this[funcName.func](node, customEventData)
        }
        
        this.onButtonClick(node, customEventData)
        this.onButtonClickName(nodeName, customEventData, node)
    }

    _ToggleClick(toggle : cc.Toggle) {
        let nodeName = toggle.node.name
        let funcName = this.onToggleClickEventFunctions ? this.onToggleClickEventFunctions[nodeName] : null
        
        if (funcName) {
            this[funcName.func](toggle)
        }
    }

    protected onButtonClick(node: cc.Node, customEventData){

    }

    protected onButtonClickName(name : string, customEventData,_node:cc.Node){

    }
    
    private registUserDataEvent(){
        let self = this
        self.onSelfCurrencyDataUpdate && self.eventBind('refresh_user_money', self.onSelfCurrencyDataUpdate)
        self.onUserDataUpdate && self.eventBind('refresh_user_data', self.onUserDataUpdate)
    }    
    getSeatNodeById(playerId:number):cc.Node
    {
        return
    }

    getTaskNode():cc.Node{
        return null;
    }

    public showView(anim ?: boolean) {
        if (this.normalShow) {
            this.node.active = true
            if (anim) {
                this.showAnim(true)
            }
        }
    }

}
